import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ColumnComponent, GridComponent, RowArgs, ScrollRequest } from "@progress/kendo-angular-grid";
import { isNullOrEmptyString } from "@progress/kendo-angular-grid/dist/es2015/utils";
import { orderBy, SortDescriptor, State } from "@progress/kendo-data-query";
import * as moment from "jalali-moment";
import { Moment } from "jalali-moment";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { isNumber } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { GridColumnInfo, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GoodsUnit, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import {
  AccountService,
  GridFilter,
  HttpCommonService,
  LookupService,
  PagingDataResult,
  ShowToastrService,
} from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { InvSubledgerDetailLedgerFormComponent } from "src/app/backoffice/inv/invvoucher/inv-subledger-detailLedger/inv-subledger-detailLedger-form.component";
import { FormOperationKind } from "src/app/backoffice/inv/models/form-operation-kind.enums";
import { Goods } from "src/app/backoffice/inv/models/goods.model";
import { InvVoucherKind } from "src/app/backoffice/inv/models/inv-voucher-kind.model";
import { ReferenceVoucherByVoucherKindFilterInfo } from "src/app/backoffice/inv/models/reference-voucher-byvoucher-kind-filter-info.model";
import { SellVoucherDetail } from "../../models/sell-voucher-detail.model";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

@Component({
  selector: "sellvoucher-detail",
  templateUrl: "./sell-voucher-detail.component.html",
  styleUrls: ["./sell-voucher-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SellVoucherDetailComponent implements OnInit {
  LookupData: Dictionary = [];
  DefaultValues: Dictionary = [];
  isLoadingData: Dictionary = [];
  _GridColumnInfo: GridColumnInfo;
  isFirstLoad: boolean;
  @ViewChild("grid") public grid: GridComponent;
  currentLookup: any;
  public isNew: boolean;
  rowseleted: boolean = false;
  isDisabled: boolean = false;
  public mySelection: number[] = [];
  isLoading: boolean = false;
  invReferenceVoucherLoded: boolean = false;
  ngUnsubscribe = new Subject<void>();
  isLoadingLastUnitPrice: boolean = false;
  @Output() valueChanges = new EventEmitter<any>();
  @Output() rowChanges = new EventEmitter<any>();
  @Output() forGoodsGroupBy = new EventEmitter();
  @Input() RowNumberName: string;
  _columns: form_control[] = [];
  @Input() set columns(value: form_control[]) {
    this._columns = value;
    if (this._columns && this._columns.length > 0) {
      this.setColumns();
      this.setColumnWith();
    }
  }
  get columns(): form_control[] {
    return this._columns;
  }
  valueIsChanging: boolean = false;
  @Input() AccountRegistered: boolean;
  @Input() HasJournalVoucher: boolean;
  @Input() isAdd: boolean = true;
  @Input() isEdit: boolean = false;
  @Input() isDelete: boolean = true;
  @Input() isPriceable: boolean = false;
  @Input() hasDiscount: boolean = false;
  @Input() ReferenceVoucherChange: (entyity: any) => void;
  @Input() hasReference: boolean = false;
  @Input() hasReferenceRequired: boolean = false;
  @Input() IsPurchaseInvoice: boolean = false;
  @Input() detailLedgerLevel: number = 0;
  @Input() IsReturnPurchaseInvoice: boolean = false;
  _filterEntity: ReferenceVoucherByVoucherKindFilterInfo;
  @Input() get filterEntity(): ReferenceVoucherByVoucherKindFilterInfo {
    return this._filterEntity;
  }
  @Input() headerTitleToDetailTitle: string;
  set filterEntity(value: ReferenceVoucherByVoucherKindFilterInfo) {
    if (
      !this._filterEntity ||
      this._filterEntity.BranchId !== value.BranchId ||
      this._filterEntity.FiscalYearId !== value.FiscalYearId ||
      this._filterEntity.DetailLedgerId !== value.DetailLedgerId ||
      this._filterEntity.ReferencedVoucherKindId !== value.ReferencedVoucherKindId ||
      this._filterEntity.VoucherKindId !== value.VoucherKindId ||
      new Date(this._filterEntity.VoucherDate).setHours(0, 0, 0, 0) !== new Date(value.VoucherDate).setHours(0, 0, 0, 0) ||
      this._filterEntity.WarehouseId !== value.WarehouseId ||
      this._filterEntity.WarehouseTransferId !== value.WarehouseTransferId
    ) {
      this.invReferenceVoucherLoded = false;
      this._filterEntity = value;
      if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);
      if (this.CurrentReferenceVoucherKind) {
        if (this.CurrentReferenceVoucherKind?.IsWarehouse === true)
          this.setelementByVoucherKindList("InvVoucherHeader/GetReferenceVoucherByVoucherKind");
        else this.setelementByVoucherKindList("SellVoucherHeader/GetReferenceVoucherByVoucherKind");
      }
    }
    this._filterEntity = value;
  }
  public isRowSelected = (e: RowArgs) => this.mySelection.indexOf(e.dataItem.RowNumber) >= 0;

  _ReferenceVoucherKindId: number;
  @Input() get ReferenceVoucherKindId(): number {
    return this._ReferenceVoucherKindId;
  }
  set ReferenceVoucherKindId(value: number) {
    this._ReferenceVoucherKindId = value;
    this.cancelHandler();
    this.setColumns();
    if (value && value > 0) {
      this.invReferenceVoucherLoded = false;
      this.isLoading = false;
      this.fillCollectionsKind(this._ReferenceVoucherKindId);
    }
    setTimeout(() => {
      if (this.dataList?.length <= 0) this.addHandler();
    }, 300);
  }
  _CurrentVoucherKind: InvVoucherKind;
  @Input() set CurrentVoucherKind(value: InvVoucherKind) {
    this._CurrentVoucherKind = value;
    this.cancelHandler();
    if (this._CurrentVoucherKind) this.setColumns();
    setTimeout(() => {
      if (this.dataList?.length <= 0) this.addHandler();
    }, 300);
  }
  get CurrentVoucherKind(): InvVoucherKind {
    return this._CurrentVoucherKind;
  }
  _CurrentWarehouseId: number;
  @Input() set CurrentWarehouseId(value: number) {
    this._CurrentWarehouseId = value;
  }
  get CurrentWarehouseId(): number {
    return this._CurrentWarehouseId;
  }
  formGroup: UntypedFormGroup;
  loadingData: boolean = false;
  _dataList: SellVoucherDetail[];
  @Input() set dataList(value: SellVoucherDetail[]) {
    this._dataList = value;
    if (this._dataList) {
      let filterddata = this._dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    }
  }
  get dataList(): SellVoucherDetail[] {
    return this._dataList;
  }
  gridData: SellVoucherDetail[];
  rowIsEditing: boolean = false;
  CurrentReferenceVoucherKind: InvVoucherKind;
  editedRow: any;
  editedRowIndex: number = 0;
  groupsName = "VoucherNo";
  isLoadingReferenceVoucherKind: boolean = false;
  public state: State = {
    skip: 0,
    take: 5,
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
  };
  get getHasTaxDuty(): boolean {
    return this.missetup.getboolean("GNR", "HasTaxDuty");
  }
  get getTaxRate(): number {
    return this.missetup.getnumber("GNR", "TaxRate") / 100;
  }

  get hasTaxDuty(): boolean {
    return this.CurrentVoucherKind && this.CurrentVoucherKind.HasTaxDuty;
  }

  getGridCell(index) {
    return this.grid?.columns?.toArray()[index];
  }
  getColumnIndex(colIndex: number) {
    if (!this.grid) return;
    let index: number = -1;
    let ColumnName: string;
    this.grid.columns
      .toArray()
      .filter((x) => x.isVisible)
      .forEach((x) => {
        index = index + 1;
        if (index == colIndex) ColumnName = x["field"];
      });
    return ColumnName;
  }
  DetailControlModels: Dictionary;
  @HostListener("window:keydown", ["$event"])
  cArrowDown(e: KeyboardEvent) {
    if (document.hidden) return;

    if (e.altKey && e.shiftKey && (e.key === "n" || e.key === "N" || e.key === "أ")) {
      e.preventDefault();
      this.addHandler();
    }
    if (e.ctrlKey && e.altKey && (e.key === "s" || e.key === "S" || e.key === "س")) {
      e.preventDefault();
      this.saveCurrent();
    }
    if (e.ctrlKey && (e.key === "c" || e.key === "C" || e.key === "ز")) {
      e.preventDefault();
      this.copyHandler();
    }
    if (e.ctrlKey && (e.key === "v" || e.key === "V" || e.key === "ر")) {
      e.preventDefault();
      this.pasetHandler();
    }
    if (e.key === "Tab" && !e.shiftKey) {
      if (this.formGroup) {
        if (this.formGroup?.valid && this.getColumnIndex(this.grid?.activeCell?.colIndex) === "Comment") {
          this.saveCurrent();
          e.preventDefault();
          if (this.grid?.activeCell?.rowIndex < this.dataList?.length) {
            this.editedRowIndex = this.grid?.activeCell?.rowIndex;
            this.cd.markForCheck();
            if (this.editedRowIndex < this.dataList?.length) this.setFormGroup(this.dataList[this.editedRowIndex]);
            else this.setFormGroup(this.dataList[this.dataList?.length - 1]);
            if (this.grid) {
              this.grid.editRow(this.editedRowIndex, this.formGroup);
            }
          } else
            setTimeout(() => {
              this.addHandler();
            }, 200);
        }
      }
    }
    if (e.key.toUpperCase() === "F4") {
      e.preventDefault();
      if (this.dataList?.length > 1 && this.formGroup?.controls["RowNumber"]?.value > 1) {
        let ColumnName = this.getColumnIndex(this.grid.activeCell.colIndex);
        if (ColumnName.includes("SubLedger") || ColumnName.includes("DetailLedger") || ColumnName.includes("Concern")) {
          let PrevValue = this.dataList[this.formGroup?.controls["RowNumber"]?.value - 2][ColumnName];
          this.formGroup.controls[ColumnName].setValue(PrevValue);
          PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Code")];
          this.formGroup.controls[ColumnName.replace("Id", "Code")].setValue(PrevValue);
          PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName.replace("Id", "Title")];
          this.formGroup.controls[ColumnName.replace("Id", "Title")].setValue(PrevValue);
        } else {
          let PrevValue = this.dataList[this.formGroup.controls["RowNumber"].value - 2][ColumnName];
          this.formGroup.controls[ColumnName].setValue(PrevValue);
          if (this.grid?.activeRow?.dataItem) this.grid.activeRow.dataItem[ColumnName] = PrevValue;
        }
        this.selectorService.onSubmited.next(true);
        this.cd.markForCheck();
      }
    }
    if (e.key.toUpperCase() === "F5") {
      e.preventDefault();
      if (!this.formGroup || !this.gridData || this.gridData.length < 2) return;
      Object.keys(this.dataList[0])
        .filter((x) => x !== "RowNumber" && x !== "Id" && x !== "State")
        .forEach((key) => {
          if (key && this.formGroup.controls[key]) {
            let PrevValue = this.gridData[this.formGroup.controls["RowNumber"].value - 2][key];
            this.formGroup.controls[key].setValue(PrevValue);
            if (this.grid?.activeRow?.dataItem) this.grid.activeRow.dataItem[key] = PrevValue;
          }
        });
      this.cd.markForCheck();
    }
    if (this.formGroup && e.ctrlKey && e.key.toUpperCase() === "DELETE") {
      e.preventDefault();
      this.removeHandler({ sender: this.grid, dataItem: this.formGroup.value });
    }
  }
  constructor(
    private lookupservice: LookupService,
    private sts: ShowToastrService,
    public cd: ChangeDetectorRef,
    private dialogService: SimpleModalService,
    private missetup: MisSetupService,
    private selectorService: SelectorService,
    private accountService: AccountService,
    private _httpCommonService: HttpCommonService
  ) {
    this.onDataStateChange = this.onDataStateChange.bind(this);
  }

  ngOnInit(): void {
    this.DefaultValues["SellVoucherHeaderId"] = 0;
    this.DefaultValues["BaseAmount"] = 0;
    this.DefaultValues["PreRemainAmount"] = 0;
    this.DefaultValues["RemainAmount"] = 0;
    this.DefaultValues["DiscountRate"] = 0;
    this.DefaultValues["DiscountAmount"] = 0;
    this.DefaultValues["GoodsUnitRatio"] = 1;
    this.DefaultValues["PriceUnitRatio"] = 0;
    this.DefaultValues["MainAmount"] = 0;
    this.DefaultValues["UnitPrice"] = 0;
    this.DefaultValues["Price"] = 0;
    this.DefaultValues["TotalPrice"] = 0;

    if (!this.dataList) this.dataList = [];

    this.columns.forEach((x) => {
      if (x.listVisible && x.apiName) this.setDropdownlist(x.apiName, x.systemName, x.category);
    });

    if (
      !this.ReferenceVoucherKindId &&
      this.CurrentVoucherKind &&
      this.CurrentVoucherKind?.ReferenceVoucherKinds &&
      this.CurrentVoucherKind?.ReferenceVoucherKinds?.length > 0
    ) {
      let vk = this.CurrentVoucherKind?.ReferenceVoucherKinds.find((vk) => vk.IsDefault);
      if (vk) this.ReferenceVoucherKindId = vk.ReferenceVoucherKindId;
    }
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    setTimeout(() => {
      if (this.dataList?.length <= 0) this.addHandler();
    }, 300);
  }
  setColumns() {
    this.columns.forEach((x) => {
      if (x.name === "Amount")
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeRefereAmount === false;
      if (x.name === "MainAmount")
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeRefereAmount === false;
      if (x.name === "UnitPrice") {
        x.listVisible = this.isPriceable || this.CurrentVoucherKind?.Priceable;
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeReferePrice === false;
      }
      if (x.name === "Price") x.listVisible = this.isPriceable || this.CurrentVoucherKind?.Priceable;
      if (x.name === "Surplusage") {
        x.listVisible = this.isPriceable || this.CurrentVoucherKind?.Priceable;
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeReferePrice === false;
      }
      if (x.name === "Deduction") {
        x.listVisible = this.isPriceable || this.CurrentVoucherKind?.Priceable;
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeReferePrice === false;
      }
      if (x.name === "DiscountRate") {
        x.listVisible = this.hasDiscount || this.CurrentVoucherKind?.HasDiscount;
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeReferePrice === false;
      }
      if (x.name === "DiscountAmount") x.listVisible = this.hasDiscount || this.CurrentVoucherKind?.HasDiscount;
      if (x.name === "Tax") {
        x.listVisible = this.isPriceable && this.hasTaxDuty;
        x.disabled =
          this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId) && this.CurrentReferenceVoucherKind?.CanChangeReferePrice === false;
      }
      if (x.name === "TotalPrice") x.listVisible = this.isPriceable || this.CurrentVoucherKind?.Priceable;
      if (x.name === "GoodsId") x.disabled = this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId);
      // if (x.name === "GoodsTitle")
      //   x.disabled = this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId);

      if (x.name === "WarehouseId") x.listVisible = this.CurrentVoucherKind?.ShowWarehouse && !this.CurrentVoucherKind?.WarehouseIsInHeader;

      if (x.name === "ReferenceId") {
        x.listVisible = this.hasReference && !isNullOrUndefined(this.ReferenceVoucherKindId);
        x.required = this.hasReference && this.hasReferenceRequired && !isNullOrUndefined(this.ReferenceVoucherKindId);
      }
    });
  }
  setFormGroup(entity: any = null) {
    let group: any = {};
    this.columns.forEach((question) => {
      switch (question.textType) {
        case "text":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.minLength && question.minLength > 0) validator.push(Validators.minLength(question.minLength));
            if (question.maxLength && question.maxLength > 0) validator.push(Validators.maxLength(question.maxLength));
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name] || null, validator)
              : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          }
          break;
        case "checkbox":
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? false : entity[question.name] || false, Validators.required)
            : new UntypedFormControl(!entity ? false : entity[question.name] || false);
          break;
        case "number":
          {
            let validator: ValidatorFn[] = [];
            if (question.required) validator.push(Validators.required);
            if (question.max && question.max > 0) validator.push(Validators.max(question.max));
            if (question.min && question.min > 0) validator.push(Validators.min(question.min));

            group[question.name] = question.required
              ? new UntypedFormControl(!entity ? null : entity[question.name] || this.DefaultValues[question.name], validator)
              : new UntypedFormControl(!entity ? this.DefaultValues[question.name] : entity[question.name] ?? this.DefaultValues[question.name]);
          }
          break;
        case "date":
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? new Date() : entity[question.name] || new Date(), Validators.required)
            : new UntypedFormControl(!entity ? new Date() : entity[question.name] || new Date());
          break;
        default:
          group[question.name] = question.required
            ? new UntypedFormControl(!entity ? null : entity[question.name] || null, Validators.required)
            : new UntypedFormControl(!entity ? null : entity[question.name] || null);
          break;
      }
    });

    group["SellVoucherHeaderId"] = new UntypedFormControl(!entity ? 0 : entity["SellVoucherHeaderId"] || 0);
    group["State"] = new UntypedFormControl(!entity ? RowState.New : entity["State"] || RowState.NoChange);
    group["Id"] = new UntypedFormControl(!entity ? 0 : entity["Id"] || 0);
    group["RowVersion"] = new UntypedFormControl(!entity ? "" : entity["RowVersion"] || "");

    if (this.RowNumberName) group[this.RowNumberName] = new UntypedFormControl(!entity ? this.gridData.length + 1 : entity[this.RowNumberName] || 0);
    this.formGroup = new UntypedFormGroup(group);
    this.setChanges();
  }
  setColumnWith() {
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      )
        x.format = "#,#.#####";
      else x.format = "";
      if (!x.columnWidth || x.columnWidth < 50) {
        if (x.textType === "text") x.columnWidth = 200;
        else x.columnWidth = 50;
      }
      if (x.name === "BranchTitle") x.disabled = true;
    });
  }
  public addHandler() {
    this.closeEditor();
    this.isNew = true;
    if (!this.dataList) this.dataList = [];
    if (this.CurrentReferenceVoucherKind) {
      if (this.CurrentReferenceVoucherKind?.IsWarehouse === true)
        this.setelementByVoucherKindList("InvVoucherHeader/GetReferenceVoucherByVoucherKind");
      else this.setelementByVoucherKindList("SellVoucherHeader/GetReferenceVoucherByVoucherKind");
    }
    this.rowIsEditing = true;
    let _comment: string = "";
    if (this.headerTitleToDetailTitle) _comment = this.headerTitleToDetailTitle;
    const temp = <SellVoucherDetail>{
      Id: -1,
      RowNumber:
        this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length > 0
          ? this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached).length + 1
          : 1,
      State: RowState.New,
      Comment: _comment,
    };
    this.dataList.push(temp);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
    this.editedRowIndex = this.gridData.length - 1;
    this.cd.markForCheck();
    this.setFormGroup(temp);
    if (this.grid) {
      this.grid.editRow(this.editedRowIndex, this.formGroup);
    }
    const keyboardEvent = new KeyboardEvent("keydown", {
      code: "Tab",
      key: "Tab",
      keyCode: 9,
      view: window,
      bubbles: true,
    });
  }
  setLastUnitPrice() {
    if (!this.isLoadingLastUnitPrice && this.CurrentVoucherKind.ShowLastUnitPrice == true && this.filterEntity.DetailLedgerId && this.formGroup) {
      let GoodsId = this.formGroup.get("GoodsId").value;
      let GoodsUnitRatio = this.formGroup.get("GoodsUnitRatio").value ?? 1;
      if (!GoodsId || this.formGroup.get("UnitPrice")?.value) return;
      this.isLoadingLastUnitPrice = true;
      this._httpCommonService
        .get(
          `InvVoucherHeader/GetPriceUnitChangeSetByGoodsId/${this.filterEntity.FiscalYearId}/${GoodsId}/${GoodsUnitRatio}/${this.filterEntity.DetailLedgerId}`
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.isLoadingLastUnitPrice = false;
            if (data) {
              this.formGroup.get("UnitPrice").setValue(data["LastUnitPrice"]);
            }
          },
          (errore) => {
            this.isLoadingReferenceVoucherKind = false;
            this.isLoadingLastUnitPrice = false;
          }
        );
    }
  }
  isvalid(entity: SellVoucherDetail) {
    if (entity.Tax && entity.Tax < 0) {
      this.sts.showDialog(`مالیات نمی تواند منفی باشد.`, "خطا", DialogType.alert);
      return false;
    }
    if (entity.UnitPrice && entity.UnitPrice < 0) {
      this.sts.showDialog(`فی نمی تواند منفی باشد.`, "خطا", DialogType.alert);
      return false;
    }

    if (entity.Surplusage && entity.Surplusage < 0) {
      this.sts.showDialog(`اضافات نمی تواند منفی باشد.`, "خطا", DialogType.alert);
      return false;
    }
    if (entity.Deduction && entity.Deduction < 0) {
      this.sts.showDialog(`کسور نمی تواند منفی باشد.`, "خطا", DialogType.alert);
      return false;
    }
    return true;
  }
  hasdatForPaset() {
    return this.selectorService.getDataList("SellVoucherDetail") !== undefined && (this.isAdd || this.isEdit);
  }
  copyHandler() {
    if (this.mySelection && this.mySelection.length > 0)
      this.selectorService.setDataList(
        "SellVoucherDetail",
        this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && this.mySelection.some((s) => s === x.RowNumber))
      );
    else
      this.selectorService.setDataList(
        "SellVoucherDetail",
        this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached && x.RowNumber === this.editedRow.RowNumber)
      );
  }
  copyAll() {
    this.selectorService.setDataList(
      "SellVoucherDetail",
      this.dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
    );
  }
  pasetHandler() {
    this.cancelHandler();
    if (this.selectorService.getDataList("SellVoucherDetail") !== undefined) {
      this.selectorService.getDataList("SellVoucherDetail").forEach((element) => {
        const entity = Object.assign({}, element as SellVoucherDetail);
        entity.RowNumber = this.dataList?.length + 1;
        entity.Id = 0;
        entity.State = RowState.New;
        this.dataList.push(entity);
      });
      this.setRowNumber();
      this.selectorService.setDataList("SellVoucherDetail", undefined);
    }
  }
  public cancelHandler() {
    this.closeEditor();
  }
  _setChanges(x: SellVoucherDetail) {
    if (x && this.valueIsChanging != true) {
      this.valueIsChanging = true;
      let Price: number = 0;
      let UnitPrice: number = 0;
      let DiscountAmount: number = 0;
      let Tax: number = 0;
      if (!x["MainAmount"] || x["MainAmount"] !== x["Amount"] * (!x["GoodsUnitRatio"] ? 1 : x["GoodsUnitRatio"])) {
        x["MainAmount"] = x["Amount"] * (!x["GoodsUnitRatio"] ? 1 : x["GoodsUnitRatio"]);
        if (this.formGroup?.controls["MainAmount"]) this.formGroup.controls["MainAmount"].setValue(x["MainAmount"]);
        if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
          this.grid.activeRow.dataItem["MainAmount"] = x["MainAmount"];
      }
      if (this.isPriceable) {
        if (this.grid && this.grid.activeCell && this.getColumnIndex(this.grid.activeCell.colIndex) === "Price") {
          UnitPrice = x["Price"] / x["Amount"];
          if (x["UnitPrice"] !== UnitPrice) {
            x["UnitPrice"] = UnitPrice;
            if (this.formGroup?.controls["UnitPrice"]) this.formGroup.controls["UnitPrice"].setValue(UnitPrice);
          }
        }
        Price = x["UnitPrice"] * x["Amount"];
        Price = isNaN(Price) ? 0 : Price;
        if (x["Price"] !== Price) {
          x["Price"] = Price;

          if (this.formGroup?.controls["Price"]) this.formGroup.controls["Price"].setValue(Price);
        }
        if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
          this.grid.activeRow.dataItem["Price"] = Price;
      } else {
        x["Price"] = 0;
        if (this.formGroup?.controls["Price"]) this.formGroup.controls["Price"].setValue(0);
        if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
          this.grid.activeRow.dataItem["Price"] = 0;
      }
      if (this.hasDiscount) {
        if (x["DiscountRate"]) {
          DiscountAmount = (Price * x["DiscountRate"]) / 100;
          if (x["DiscountAmount"] !== DiscountAmount) {
            x["DiscountAmount"] = DiscountAmount;
            if (this.formGroup?.controls["DiscountAmount"]) this.formGroup.controls["DiscountAmount"].setValue(DiscountAmount);
          }
        }
      }
      if (this.hasTaxDuty && this.getHasTaxDuty && x["HasTaxDuty"] && (x["TaxRate"] !== undefined || this.getTaxRate > 0)) {
        let TotalPrice = Price - DiscountAmount + (x["Surplusage"] ?? 0) - (x["Deduction"] ?? 0);
        Tax = TotalPrice * (x["TaxRate"] !== undefined && x["TaxRate"] !== null ? x["TaxRate"] / 100 : this.getTaxRate);
        if (x["Tax"] !== Tax) {
          x["Tax"] = Tax;
          if (this.formGroup?.controls["Tax"]) this.formGroup.controls["Tax"].setValue(Tax);
          if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
            this.grid.activeRow.dataItem["Tax"] = Tax;
        }
      } else {
        x["Tax"] = 0;
        if (this.formGroup?.controls["Tax"]) this.formGroup.controls["Tax"].setValue(0);
        if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"]) this.grid.activeRow.dataItem["Tax"] = 0;
      }

      if (this.isPriceable) {
        let TotalPrice = Price + Tax - DiscountAmount + (x["Surplusage"] ?? 0) - (x["Deduction"] ?? 0);
        if (x["TotalPrice"] !== TotalPrice) {
          x["TotalPrice"] = TotalPrice;
          if (this.formGroup?.controls["TotalPrice"]) this.formGroup.controls["TotalPrice"].setValue(TotalPrice);
          if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
            this.grid.activeRow.dataItem["TotalPrice"] = TotalPrice;
        }
      } else {
        x["TotalPrice"] = 0;
        if (this.formGroup?.controls["TotalPrice"]) this.formGroup.controls["TotalPrice"].setValue(0);
        if (this.grid?.activeRow?.dataItem && this.grid?.activeRow?.dataItem["RowNumber"] === x["RowNumber"])
          this.grid.activeRow.dataItem["TotalPrice"] = 0;
      }
      this.valueIsChanging = false;
      //this.valueChanges.emit(x);
    }
  }
  setChanges() {
    if (this.formGroup)
      this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        setTimeout(() => (this.valueIsChanging = false), 100);
        this._setChanges(x);
      });
    this.fitColumns();
  }
  public saveHandler(rowIndex, formGroup): void {
    if (this.formGroup && this.formGroup?.valid && this.isvalid(this.formGroup.value)) {
      var entity = this.formGroup.value;
      this._setChanges(entity);
      Object.keys(this.DefaultValues).forEach((key) => {
        if (!entity[key]) entity[key] = this.DefaultValues[key];
      });
      if (entity.State === undefined || (entity.State === RowState.New && rowIndex === -1)) {
        entity.State = RowState.New;
        if (!this.gridData.some((x) => x.RowNumber === entity.RowNumber)) this.dataList.push(entity);
      } else if (rowIndex >= 0) {
        if (!entity.State) entity.State = this.dataList[rowIndex].State;

        if (entity.State != RowState.New) (entity as SellVoucherDetail).State = RowState.Modify;
        if (entity.Id > 0 && this.dataList.some((x) => x.Id === entity.Id)) {
          this.dataList.forEach((m) => {
            if (m.Id === entity.Id) {
              Object.assign(m, entity);
            }
          });
        } else {
          this.dataList.forEach((m) => {
            if (m.RowNumber === entity.RowNumber && m.Id === entity.Id && m.State === entity.State) {
              if (entity.Id == -1) entity.Id = 0;
              Object.assign(m, entity);
            }
          });
        }
      }
      this.rowIsEditing = false;
      this.valueChanges.emit(entity);
      this.closeEditor();
      let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      this.cd.markForCheck();
    } else this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
    this.cd.markForCheck();
  }
  deleteFormHelper(dataItem: any) {
    this.dataList.forEach((x) => {
      if ((dataItem.Id > 0 && x.Id === dataItem.Id) || x === dataItem) {
        if (x.State === RowState.New) x.State = RowState.Detached;
        else x.State = RowState.Delete;
        this.valueChanges.emit(x);
      }
    });
    this.setRowNumber();
  }
  setRowNumber() {
    let index: number = 0;
    this.gridData
      .filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached)
      .sort((a, b) => a.RowNumber - b.RowNumber)
      .forEach((x) => {
        index += 1;
        x.RowNumber = index;
      });
    this.valueChanges.emit(this.gridData[this.gridData.length - 1]);
    let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
  }
  public removeHandler({ sender, dataItem }): void {
    this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(dataItem));
    sender.cancelCell();
  }

  private closeEditor() {
    this.editedRow = undefined;
    if (this.grid) this.grid.closeRow(this.editedRowIndex);
    this.rowIsEditing = false;
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
    if (this.dataList) {
      this.dataList = this.dataList.filter((x) => x.Id >= 0);
      let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0);
      this.gridData = filterddata?.sort((a, b) => a.RowNumber - b.RowNumber);
    }
    this.cd.markForCheck();
  }

  private isReadOnly(field: string, dataItem: any): boolean {
    let col = this.columns.find((x) => x.name === field);
    return col && col.disabled;
  }
  public saveCurrent(): void {
    if (this.formGroup) {
      this.saveHandler(this.editedRowIndex, this.formGroup);
    }
  }

  hasMultiColumns(ColumnsName: string) {
    if (!ColumnsName) return false;
    var columns = ColumnsName.split(",");
    return columns.length > 1;
  }
  fillCollectionsKind(ReferenceVoucherKindId: number) {
    if (!this.isLoadingReferenceVoucherKind) {
      this.filterEntity.ReferencedVoucherKindId = ReferenceVoucherKindId;
      this.isLoadingReferenceVoucherKind = true;
      this._httpCommonService
        .getItem<InvVoucherKind>("InvVoucherKind", ReferenceVoucherKindId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            if (data) {
              this.isLoadingReferenceVoucherKind = false;
              this.CurrentReferenceVoucherKind = Object.assign({}, data as InvVoucherKind);
              if (this.CurrentReferenceVoucherKind)
                if (this.CurrentReferenceVoucherKind?.IsWarehouse === true)
                  this.setelementByVoucherKindList("InvVoucherHeader/GetReferenceVoucherByVoucherKind");
                else this.setelementByVoucherKindList("SellVoucherHeader/GetReferenceVoucherByVoucherKind");
              if (
                this.CurrentReferenceVoucherKind?.IsWarehouse !== true &&
                this.columns?.find((x) => x.apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind")?.apiName
              )
                this.columns.find((x) => x.apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind").apiName =
                  "SellVoucherHeader/GetReferenceVoucherByVoucherKind";
            }
          },
          (errore) => (this.isLoadingReferenceVoucherKind = false)
        );
    }
  }
  onRowsSelected($event, apiName: string, key: string) {
    let hasNewRecord: Boolean = false;
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    if (
      $event &&
      apiName !== "InvVoucherHeader/GetReferenceVoucherByVoucherKind" &&
      apiName !== "SellVoucherHeader/GetReferenceVoucherByVoucherKind"
    ) {
      if ($event.length > 1) {
        $event.forEach((x) => {
          let entity = <SellVoucherDetail>{};
          entity.RowNumber =
            this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0).length > 0
              ? this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0).length + 1
              : 1;
          entity[key] = x["Id"];
          entity.GoodsTitle = x["Title"];
          entity.GoodsCode = x["Code"];
          entity.MainUnitId = x["UnitId"];
          entity.GoodsMainUnitCode = x["UnitCode"];
          entity.GoodsMainUnitTitle = x["UnitTitle"];
          entity.PriceUnitId = x["DefaultUnitId"];
          entity.GoodsUnitTitle = x["DefaultUnitTitle"];
          entity.GoodsUnitId = x["DefaultUnitId"];
          entity.GoodsKindCode = x["GoodsKindCode"];
          entity.HasTaxDuty = x["HasTaxDuty"];
          entity.State = RowState.New;
          entity.Id = 0;
          if (!this.dataList.some((f) => f[key] === x["Id"] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete)) {
            this.dataList.push(entity);
            hasNewRecord = true;
          }
        });
        let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
        this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
        if (hasNewRecord) this.closeEditor();
      }
    }
    if (
      $event &&
      (apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind" || apiName === "SellVoucherHeader/GetReferenceVoucherByVoucherKind")
    ) {
      if (this.ReferenceVoucherChange) this.ReferenceVoucherChange($event[0]);
      $event.forEach((element) => {
        if (element && !this.gridData.some((x) => x.ReferenceId === element.Id)) {
          let entity: SellVoucherDetail = <SellVoucherDetail>{};
          entity.Id = 0;
          entity.State = RowState.New;
          entity.RowNumber =
            this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0).length > 0
              ? this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached && x.Id >= 0).length + 1
              : 1;
          if (element.BaseRemainAmount) entity.BaseAmount = element.BaseRemainAmount;
          else entity.BaseAmount = element.RemainAmount;
          if (entity.BaseAmount <= 0 && element.RemainMainAmount > 0)
            entity.BaseAmount = element.RemainMainAmount /= element.GoodsUnitRatio <= 0 ? 1 : element.GoodsUnitRatio;
          entity.Amount = element.RemainAmount;

          if (element.PreRemainAmount !== null && element.PreRemainAmount !== undefined && element.PreRemainAmount !== 0)
            entity.PreRemainAmount = element.PreRemainAmount;
          else entity.PreRemainAmount = element.RemainAmount;
          entity.ExpiryDate = element.ExpiryDate;
          entity.RemainAmount = element.RemainAmount;
          if (element.Amount === entity.BaseAmount) entity.Amount = element.Amount;
          else entity.Amount = entity.BaseAmount;
          entity.MainAmount = (element.GoodsUnitRatio <= 0 ? 1 : element.GoodsUnitRatio) * entity.Amount;
          entity.Comment = element.Comment;

          entity.GoodsCode = element.GoodsCode;
          entity.GoodsId = element.GoodsId;
          entity.GoodsTitle = element.GoodsTitle;
          entity.GoodsUnitId = element.GoodsUnitId;
          entity.GoodsMainUnitTitle = element.MainUnitTitle;
          entity.GoodsUnitTitle = element.GoodsUnitTitle;
          entity.GoodsUnitRatio = element.GoodsUnitRatio;
          entity.GoodsKindCode = element.GoodsKindCode;
          entity.HasTaxDuty = element.HasTaxDuty;
          entity.TaxRate = element.TaxRate;

          entity.DetailLedgerId = element.DetailLedgerId;
          entity.DetailLedgerCode = element.DetailLedgerCode;
          entity.DetailLedgerTitle = element.DetailLedgerTitle;
          entity.DetailLedgerLatinTitle = element.DetailLedgerLatinTitle;
          entity.DetailLedger2Id = element.DetailLedger2Id;
          entity.DetailLedger2Code = element.DetailLedger2Code;
          entity.DetailLedger2Title = element.DetailLedger2Title;
          entity.DetailLedger2LatinTitle = element.DetailLedger2LatinTitle;
          entity.DetailLedger3Id = element.DetailLedger3Id;
          entity.DetailLedger3Code = element.DetailLedger3Code;
          entity.DetailLedger3Title = element.DetailLedger3Title;
          entity.DetailLedger3LatinTitle = element.DetailLedger3LatinTitle;
          entity.DetailLedger4Id = element.DetailLedger4Id;
          entity.DetailLedger4Code = element.DetailLedger4Code;
          entity.DetailLedger4Title = element.DetailLedger4Title;
          entity.DetailLedger4LatinTitle = element.DetailLedger4LatinTitle;
          entity.DetailLedger5Id = element.DetailLedger5Id;
          entity.DetailLedger5Code = element.DetailLedger5Code;
          entity.DetailLedger5Title = element.DetailLedger5Title;
          entity.DetailLedger5LatinTitle = element.DetailLedger5LatinTitle;

          entity.DiscountAmount = element.DiscountAmount ?? 0;
          entity.DiscountRate = element.DiscountRate ?? 0;
          entity.Surplusage = element.Surplusage ?? 0;
          entity.Deduction = element.Deduction ?? 0;
          entity.Tax = element.Tax ?? 0;
          if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);
          if (this.CurrentReferenceVoucherKind !== null) {
            if (this.CurrentReferenceVoucherKind && this.CurrentReferenceVoucherKind?.IsWarehouse == true) entity.InvReferenceId = element.Id;
          }
          entity.ReferenceId = element.Id;
          entity.ReferenceCode = element.VoucherNo;

          entity.TeloranceAmount = element.TeloranceAmount;
          entity.TraceElement = element.TraceElement;
          // if ((this.CurrentReferenceVoucherKind !== null && this.CurrentReferenceVoucherKind?.IsWarehouse) && this.CurrentVoucherKind.IncrementalKindCode !== 2)
          entity.UnitPrice = element.UnitPrice ?? 0;
          if (!entity.UnitPrice) entity.UnitPrice = 0;
          entity.Price = element.Price;
          entity.Price = Math.round(entity.UnitPrice * entity.Amount);
          entity.PriceUnitId = element.PriceUnitId;
          entity.TotalPrice =
            entity.Amount * (entity.UnitPrice ?? 0) +
            (entity.Tax ? entity.Tax : 0) -
            (entity.DiscountAmount ? entity.DiscountAmount : 0) +
            (entity.Surplusage ? entity.Surplusage : 0) -
            (entity.Deduction ? entity.Deduction : 0);
          if (
            !this.dataList.some(
              (f) => (f.ReferenceId === element.Id || f.InvReferenceId === element.Id) && f.State !== RowState.Delete && f.State !== RowState.Detached
            )
          ) {
            this.dataList.push(entity);
            hasNewRecord = true;
          }
        }
      });
      if (this.dataList?.length > 0) this.valueChanges.emit(this.dataList[this.dataList?.length - 1]);
      let filterddata = this.dataList.filter((x) => x.Id >= 0 && x.State != RowState.Delete && x.State != RowState.Detached);
      this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
      if (hasNewRecord) this.closeEditor();
      this.cd.markForCheck();
    }
    this.valueChanges.emit(this.dataList[0]);
  }

  setelementByVoucherKindList(apiName: string) {
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    if (!this.isLoading && !this.invReferenceVoucherLoded && this.filterEntity.VoucherDate) {
      this.isLoading = true;
      let model = Object.assign({}, this.filterEntity);
      if (this.CurrentVoucherKind?.HasWarehouseTransfer) {
        model.WarehouseTransferId = this.filterEntity.WarehouseId;
        model.WarehouseId = this.filterEntity.WarehouseTransferId;
      }
      this._httpCommonService
        .create(apiName, model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.isLoading = false;
            if (apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind" || "SellVoucherHeader/GetReferenceVoucherByVoucherKind") {
              this.selectorService.setDataList("ReferenceId", x as []);
              if (x && (x as []).length > 0) this.invReferenceVoucherLoded = true;
            } else this.LookupData[apiName] = x;
          },
          (error) => (this.isLoading = false)
        );
    }
  }
  setDropdownlist(apiName: string, systemName: string, category: string) {
    if (
      (apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind" || apiName === "SellVoucherHeader/GetReferenceVoucherByVoucherKind") &&
      this.ReferenceVoucherKindId &&
      this.ReferenceVoucherKindId > 0
    ) {
      this.setelementByVoucherKindList(apiName);
    }
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    if (apiName === "Goods/ReadGoodsUnitLookUp") return;
    if (systemName && category && !this.loadingData) {
      this.lookupservice
        .getLookupbyCategory(systemName, category)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.LookupData[apiName] = x;
        });
    } else
      this._httpCommonService
        .getList(apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.LookupData[apiName] = x;
        });
  }
  getItemDisplayById(apiName: string, systemName: string, id: number, displayMember, valueMember: string, dataItem: any, columnName: string) {
    if (!id) return "";
    if (apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind" || apiName === "SellVoucherHeader/GetReferenceVoucherByVoucherKind") {
      if (dataItem["ReferenceCode"]) return dataItem["ReferenceCode"];
      else return "";
    }

    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    if (apiName.includes("Goods") && dataItem[`Goods${displayMember}`]) return dataItem[`Goods${displayMember}`];
    else return dataItem[`${columnName.replace("Id", displayMember)}`];
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.selectorService.setDataList("SellVoucherDetail", undefined);
    this.selectorService.setDataList("ReferenceId", undefined);
    //window.removeEventListener('keydown', this.cArrowDown.bind(this), false);
    this.saveGridColumnInfo();
    this.LookupData = undefined;
    this.DefaultValues = undefined;
    this.isLoadingData = undefined;
    this.grid = undefined;
    this.currentLookup = undefined;
    this.mySelection = undefined;
    this.columns = undefined;
    this._filterEntity = undefined;
    this.CurrentVoucherKind = undefined;
    this.formGroup = undefined;
    this._dataList = undefined;
    this.gridData = undefined;
    this.CurrentReferenceVoucherKind = undefined;
    this.editedRow = undefined;
  }
  setValue(key: string, value: any) {
    if (!this.formGroup?.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
    else if (this.formGroup) this.formGroup.controls[key].setValue(value);
  }
  setGoods(event: any) {
    this.setValue("GoodsTitle", event.Title);
    this.setValue("GoodsCode", event.Code);
    this.setValue("MainUnitId", event.UnitId);
    this.setValue("GoodsMainUnitCode", event.UnitCode);
    this.setValue("GoodsMainUnitTitle", event.UnitTitle);
    this.setValue("PriceUnitId", this.formGroup?.get("PriceUnitId")?.value ?? event.DefaultUnitId);
    this.setValue("GoodsUnitId", this.formGroup?.get("GoodsUnitId")?.value ?? event.DefaultUnitId);
    this.setValue("GoodsUnitTitle", this.formGroup?.get("GoodsUnitTitle")?.value ?? event.DefaultUnitTitle ?? event.UnitTitle);
    this.setValue("GoodsKindCode", event.GoodsKindCode);
    this.setValue("HasTaxDuty", event.HasTaxDuty);
    this.setValue("TaxRate", event.TaxRate);
    if (event.DetailLedgerId) {
      this.setValue("GoodsDetailLedgerId", event.DetailLedgerId);
      this.setValue("GoodsDetailLedgerCode", event.DetailLedgerCode);
      this.setValue("GoodsDetailLedgerTitle", event.DetailLedgerTitle);
    }
    if (
      event.CostSubLedgerId &&
      ((this.CurrentVoucherKind.FormOperationKindCode === FormOperationKind.IsPurchaseService) === true ||
        (this.CurrentVoucherKind.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) === true)
    ) {
      this.setValue("CostSubLedgerId", event.CostSubLedgerId);
      this.setValue("CostSubLedgerCode", event.CostSubLedgerCode);
      this.setValue("CostSubLedgerTitle", event.CostSubLedgerTitle);
    }
    if (event.GoodsGroupDetailLedgerId) {
      this.setValue("GoodsGroupDetailLedgerId", event.GoodsGroupDetailLedgerId);
      this.setValue("GoodsGroupDetailLedgerCode", event.GoodsGroupDetailLedgerCode);
      this.setValue("GoodsGroupDetailLedgerTitle", event.GoodsGroupDetailLedgerTitle);
    }
    this.rowChanges.emit(this.formGroup?.value);
    setTimeout(() => {
      if (this.grid?.activeRow?.dataItem) {
        this.grid.activeRow.dataItem["GoodsTitle"] = event.Title;
        this.grid.activeRow.dataItem["GoodsUnitTitle"] = this.formGroup?.get("GoodsUnitTitle")?.value ?? event.DefaultUnitTitle;
      }
      this.formGroup.updateValueAndValidity();
      this.cd.markForCheck();
    }, 300);
  }
  removeGoods() {
    this.setValue("GoodsId", undefined);
    this.setValue("GoodsTitle", undefined);
    this.setValue("GoodsCode", undefined);
    this.setValue("MainUnitId", undefined);
    this.setValue("GoodsMainUnitCode", undefined);
    this.setValue("GoodsMainUnitTitle", undefined);
    this.setValue("PriceUnitId", undefined);
    this.setValue("GoodsUnitId", undefined);
    this.setValue("GoodsUnitTitle", undefined);
    this.setValue("GoodsKindCode", undefined);
    this.setValue("HasTaxDuty", undefined);
    this.setValue("TaxRate", undefined);
    this.rowChanges.emit(this.formGroup?.value);
    setTimeout(() => {
      if (this.grid?.activeRow?.dataItem) this.grid.activeRow.dataItem["GoodsTitle"] = undefined;
      this.formGroup.updateValueAndValidity();
      this.cd.markForCheck();
    }, 300);
  }
  selectionChange(event: any, apiName: string, columnName: string) {
    this.currentLookup = event;
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    if (apiName === "InvVoucherHeader/GetReferenceVoucherByVoucherKind" || apiName === "SellVoucherHeader/GetReferenceVoucherByVoucherKind") {
      if (event && !this.CurrentVoucherKind.BasedOnBOM) this.onRowsSelected([event], apiName, "");
      return;
    }
    this.valueChanges.emit(event);
    if (event && event.DefaultUnitId) {
      if (this.formGroup) {
        if (this.isNew) {
          if (this.dataList.some((s) => s.GoodsId === event.Id && s.State !== RowState.Delete && s.State !== RowState.Detached)) {
            this.sts.showDialog(
              "این کالا قبلا انتخاب شده تکراری است. آیا تایید می کنید.",
              "حذف اطلاعات",
              DialogType.confirm,
              () => {
                this.setGoods(event);
              },
              () => {
                this.removeGoods();
              }
            );
          } else this.setGoods(event);
        } else this.setGoods(event);
      }
      this.setGoodUnitList(event);
      this.setLastUnitPrice();
    }
    if (event && event.UnitId && this.formGroup && event.GoodsId && event.Ratio) {
      this.setValue("GoodsUnitTitle", event.UnitTitle);
      this.setValue("GoodsMainUnitTitle", event.UnitTitle);
      this.setValue("GoodsUnitCode", event.UnitCode);
      this.setValue("PriceUnitId", event.UnitId);
      this.setValue("GoodsUnitRatio", !event.Ratio ? 1 : event.Ratio);

      this.setLastUnitPrice();
    } else if (event.Code) {
      this.setValue(`${columnName.replace("Id", "Title")}`, event.Title);
      this.setValue(`${columnName.replace("Id", "Code")}`, event.Code);
    }
  }
  setGoodUnitList(goods: Goods) {
    this._httpCommonService
      .getList("Goods/ReadGoodsUnitLookUp/" + goods.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: any[]) => {
          //x.push(<GoodsUnit>{ GoodsId: null, Ratio: null, UnitId: null, UnitTitle: 'تهی کردن اطلاعات', UnitCode: null });
          if (x.length === 0 && !x.some((u) => u.UnitId === goods.DefaultUnitId))
            x.push(<GoodsUnit>(<unknown>{
              GoodsId: goods.Id,
              Ratio: 1,
              UnitId: goods.DefaultUnitId,
              UnitTitle: goods.DefaultUnitTitle,
              UnitCode: goods.DefaultUnitCode,
            }));
          if (!x.some((u) => u.UnitId === goods.UnitId))
            x.push(<GoodsUnit>(<unknown>{ GoodsId: goods.Id, Ratio: 1, UnitId: goods.UnitId, UnitTitle: goods.UnitTitle, UnitCode: goods.UnitCode }));
          if (this.formGroup) {
            let du = x.find((d) => d.UnitId === (this.formGroup?.get("GoodsUnitId")?.value ?? goods.DefaultUnitId));
            if (du) {
              this.setValue("GoodsUnitRatio", !du.Ratio ? 1 : du.Ratio);
            } else {
              this.setValue("GoodsUnitRatio", 1);
            }
          }
          this.LookupData["Goods/ReadGoodsUnitLookUp"] = x;
        },
        (error) => {}
      );
  }
  getDateValue(date: Date) {
    let m: Moment = moment(date.toString()).locale("fa");
    return m.format("YYYY/MM/DD");
  }
  getFilters(columnsName: string, searchValue: string, skip: number, take: number) {
    var filters: GridFilter[] = [];
    const columns = columnsName.split(",");
    if (isNullOrEmptyString(searchValue)) return filters;
    columns.forEach((x) => {
      {
        if (x !== "Id")
          filters.push({ Filed: x, Operator: "contains", Type: "F", Skip: skip, Take: take, Value: searchValue.toString(), Logic: "or" });
        else if (isNumber(searchValue))
          filters.push({ Filed: x, Operator: "eq", Type: "F", Skip: skip, Take: take, Value: Number(searchValue), Logic: "or" });
      }
    });
    return filters;
  }
  onDataStateChange(columnName: string, searchValue: string, skip: number, take: number): Observable<PagingDataResult<Goods>> {
    if (!this.CurrentReferenceVoucherKind && this.ReferenceVoucherKindId) this.fillCollectionsKind(this.ReferenceVoucherKindId);

    var abs = new BehaviorSubject<PagingDataResult<Goods>>(null);
    const GoodsGroupIds: number[] = [];
    let apiName: string = "Goods/GoodsByGoodsGroupIds";
    const filter = this.getFilters("Id,Code,Title,Unit.Title,GoodsKind.Title", searchValue, skip, take);
    if (this.CurrentVoucherKind.FormOperationKindCode === FormOperationKind.IsPurchaseService) {
      filter.push({ Filed: "IsGoods", Operator: "eq", Value: false, Type: "F", Skip: skip, Take: take, Logic: "and" });
    }
    if (this.CurrentVoucherKind.VoucherKindGoodss && this.CurrentVoucherKind.VoucherKindGoodss.length > 0) {
      this.CurrentVoucherKind.VoucherKindGoodss.forEach((x) => GoodsGroupIds.push(x.GoodsGroupId));
    }
    if (!filter.some((x) => x.Filed === "WarehouseId"))
      filter.push({ Filed: "WarehouseId", Operator: "eq", Value: this.CurrentWarehouseId, Type: "F", Skip: skip, Take: take, Logic: "and" });
    if (GoodsGroupIds && GoodsGroupIds.length > 0)
      filter.push({ Filed: "GoodsGroupIds", Operator: "eq", Value: GoodsGroupIds, Type: "F", Skip: skip, Take: take, Logic: "and" });
    if (!this.isLoadingData[apiName]) {
      this.isLoadingData[apiName] = true;
      if (filter.length <= 0) filter.push({ Filed: "Code", Type: "S", Skip: skip, Take: take, Value: "0", Operator: "asc" });
      this._httpCommonService
        .GetFilterGrid<PagingDataResult<Goods>>(apiName, filter)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x: PagingDataResult<Goods>) => {
            if (x) abs.next(x);
            this.isLoadingData[apiName] = false;
          },
          (error) => (this.isLoadingData[apiName] = false)
        );
    }
    return abs.asObservable();
  }
  setColumnInfo(columnInfos: GridColumnInfoDetail[]) {
    if (!this.grid)
      setTimeout(() => {
        this.setColumnInfo(columnInfos);
      }, 50);

    if (this.grid?.columns) {
      if (this.grid.columns.length <= 1) {
        setTimeout(() => this.setColumnInfo(columnInfos), 200);
      }
    }
    if (this.grid?.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        const column = columnInfos.find((c) => c.name === (x.field ?? x.title));
        if (column) {
          x.leafIndex = column.leaftindex;
          x.orderIndex = column.orderindex;
          x.minResizableWidth = column.minResizableWidth;
          x.width = column.width;
          x.hidden = column.hidden;
        }
      });
    }
    this.isFirstLoad = true;
    this.cd.detectChanges();
    setTimeout(() => {
      const firstCol: ScrollRequest = {};
      firstCol.column = 0;
      if (this.grid && firstCol) this.grid?.scrollTo(firstCol);
    }, 110);
  }
  setDefaultColumnInfo() {
    this.grid?.columns?.forEach((x: ColumnComponent) => {
      if (x.title === "عملیات") {
        x.width = 70;
        x.minResizableWidth = 60;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      if (!x.title && !x.field) {
        x.width = x.width;
        x.minResizableWidth = x.minResizableWidth;
        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
      const column = this.columns.find((c) => c.name === (x.field ?? x.title));
      if (column) {
        x.width = column.columnWidth;
        x.minResizableWidth = x.minResizableWidth;
        x.hidden = !column.listVisible;

        x.leafIndex = undefined;
        x.orderIndex = 0;
      }
    });
    this.cd.markForCheck();
  }
  async saveGridColumnInfo() {
    const list: GridColumnInfoDetail[] = [];
    if (this.grid && this.grid.columns) {
      this.grid.columns.forEach((x: ColumnComponent) => {
        if (x) {
          const column = new GridColumnInfoDetail();
          column.leaftindex = x.leafIndex;
          column.orderindex = x.orderIndex;
          column.hidden = x.hidden;
          column.name = x.field ?? x.title;
          column.width = x.width;
          column.minResizableWidth = x.minResizableWidth;
          column.title = x.title;
          list.push(column);
        }
      });
      if (!this._GridColumnInfo) this._GridColumnInfo = new GridColumnInfo();
      this._GridColumnInfo.Key = this.CurrentVoucherKind?.Id ? `SellVoucherDetail_${this.CurrentVoucherKind?.Id}` : "SellVoucherDetail";
      this._GridColumnInfo.ColumnInfo = JSON.stringify(list);
      this._GridColumnInfo.CreatedUserId = this.accountService.authService.currentUser.Id;
      if (this.state.group && this.state.group.length > 0) this._GridColumnInfo.Group = JSON.stringify(this.state.group);
      else this._GridColumnInfo.Group = undefined;
      await this._httpCommonService.updateItem("MisSetUp/UpdateGridColumnInfo", this._GridColumnInfo).pipe(takeUntil(this.ngUnsubscribe)).toPromise();
    }
  }
  async fitColumns() {
    if (!this.isFirstLoad) {
      if (this._GridColumnInfo) {
        let columnInfos: GridColumnInfoDetail[] = JSON.parse(this._GridColumnInfo.ColumnInfo);
        this.setColumnInfo(columnInfos);
      } else {
        const x = await this._httpCommonService
          .get(
            "MisSetUp/GetGridColumnInfo/?key=" +
              (this.CurrentVoucherKind?.Id ? `SellVoucherDetail_${this.CurrentVoucherKind.Id}` : "SellVoucherDetail") +
              `&CreatedUserId=${this.accountService.authService.currentUser.Id}`
          )
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise();
        if (x) {
          this._GridColumnInfo = x as GridColumnInfo;
          this.setColumnInfo(JSON.parse(x["ColumnInfo"]));
          if (this._GridColumnInfo.Group) {
            this.state.group = JSON.parse(x["Group"]);
          }
        } else this.setDefaultColumnInfo();

        this.isFirstLoad = true;
      }
    }
    setTimeout(
      () => {
        this.cd.detectChanges();
        this.cd.markForCheck();
      },
      this.isFirstLoad ? 500 : 200
    );

    this.cd.markForCheck();
  }
  public cellCloseHandler(args: any) {
    const { formGroup, dataItem } = args;
    if (!formGroup.valid) {
      return;
    } else if (formGroup.dirty) {
      this.saveCurrent();
    } else this.closeEditor();
  }
  public editHandler({ sender, rowIndex, dataItem }) {
    this.editedRow = undefined;
    if (this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== rowIndex)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: dataItem });
    if (this.rowIsEditing) return;
    if (dataItem) this.valueChanges.emit(dataItem);
    if (!this.isAdd && !this.isEdit) {
      this.valueChanges.emit(dataItem);
      return;
    }
    this.setFormGroup(dataItem);

    this.rowIsEditing = true;
    this.editedRowIndex = rowIndex;
    this.valueChanges.emit(dataItem);
    this.grid.editRow(rowIndex, this.formGroup);
    setTimeout(() => {
      if (this.grid) this.grid.focus();
      this.cd.markForCheck();
      if (this.formGroup) this.formGroup.updateValueAndValidity();
    }, 500);
    if (this.formGroup?.value?.GoodsId > 0) this.setGoodsUnitLookUp();
  }
  setGoodsUnitLookUp() {
    this._httpCommonService
      .getItem("Goods", this.formGroup.value.GoodsId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.setGoodUnitList(x as Goods);
        },
        (error) => {}
      );
  }
  public onUserRowSelect({ sender, column, rowIndex, columnIndex, dataItem }): void {
    this.editedRow = dataItem;
    this.valueChanges.emit(this.editedRow);
  }
  public doubleclic(args: any) {
    this.editedRow = undefined;
    if (this.editedRowIndex !== undefined && this.editedRowIndex >= 0 && this.editedRowIndex !== this.grid.activeRow.index - 1)
      this.cellCloseHandler({ formGroup: this.formGroup, dataItem: this.grid.activeRow.dataItem });
    this.editHandler({ sender: this.grid, rowIndex: this.grid.activeRow.index - 1, dataItem: this.grid.activeRow.dataItem });
  }

  onKeyup($event) {
    if ($event.key === "Escape") {
      this.cd.markForCheck();
      if (this.formGroup) this.formGroup.updateValueAndValidity();
      if (!(this.formGroup && (this.formGroup.touched || this.formGroup.dirty))) this.cancelHandler();
    }
  }
  sortChange(sort: SortDescriptor[]) {
    this.state.sort = sort;
    this.gridData = orderBy(this.gridData, sort);
  }
  editSubledgerDetailLedger() {
    this.dialogService
      .open(
        InvSubledgerDetailLedgerFormComponent,
        {
          label: "اصلاح معین و تفصیلی",
          currentrow: this.editedRow,
          Columns: this.columns,
          CurrentVoucherKind: this.CurrentVoucherKind,
          detailLedgerLevel: this.detailLedgerLevel,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          if (model.Id > 0 && this.dataList.some((x) => x.Id === model.Id)) {
            this.dataList.forEach((m) => {
              if (m.Id === model.Id) {
                if (m !== model) model.State = RowState.Modify;
                Object.assign(m, model);
              }
            });
          } else {
            this.dataList.forEach((m) => {
              if (m.RowNumber === model.RowNumber && m.Id === model.Id && m.State === model.State) {
                if (model.Id == -1) model.Id = 0;
                if (m !== model) m.State = RowState.Modify;
                Object.assign(m, model);
              }
            });
          }
          this.valueChanges.emit(model);
          this.closeEditor();
          let filterddata = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
          this.gridData = filterddata.sort((a, b) => a.RowNumber - b.RowNumber);
          this.cd.markForCheck();
        }
      });
  }
}
